export default __webpack_public_path__ + "static/29-022838d809739726b682ded8ec05d278.png";